/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BankAccountPayment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import PaymentProviderMethod from 'DesignSystem/PaymentProvider/PaymentProviderMethod/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function BankAccountPayment({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsPostPayment/Content/Content/Content/PaymentMethods/BankAccountPayment"
  
}) {
let paymentsPostPaymentLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'payments_post_payment',
path: 'location_id',
})
let paymentsPostPaymentPaymentAccountPayerPersonValueData = fromData.useDataValue({ viewPath,
context: 'payments_post_payment',
path: 'payment_account.payer_person',
})
let paymentsPostPaymentPaymentAccountAccountTypeValueData = fromData.useDataValue({ viewPath,
context: 'payments_post_payment',
path: 'payment_account.account_type',
})
let paymentsPostPaymentAmountValueData = fromData.useDataValue({ viewPath,
context: 'payments_post_payment',
path: 'amount',
})
  return (<React.Fragment
>
<PaymentProviderMethod
  viewPath={`${viewPath}/PaymentProviderMethod`}
 method="ach"
 data="payments_post_payment.location_id"
 locationId={paymentsPostPaymentLocationIdValueData}
 data="payments_post_payment.payment_account.payer_person"
 person={paymentsPostPaymentPaymentAccountPayerPersonValueData}
 data="payments_post_payment.payment_account.account_type"
 paymentAccountType={paymentsPostPaymentPaymentAccountAccountTypeValueData}
 data="payments_post_payment.amount"
 amount={paymentsPostPaymentAmountValueData}
/>
{children}
</React.Fragment>)
}